(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6579],{

/***/ 4795:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ icons_DollarOutlined; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(1413);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/DollarOutlined.js
// This icon file is generated automatically.
var DollarOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm47.7-395.2l-25.4-5.9V348.6c38 5.2 61.5 29 65.5 58.2.5 4 3.9 6.9 7.9 6.9h44.9c4.7 0 8.4-4.1 8-8.8-6.1-62.3-57.4-102.3-125.9-109.2V263c0-4.4-3.6-8-8-8h-28.1c-4.4 0-8 3.6-8 8v33c-70.8 6.9-126.2 46-126.2 119 0 67.6 49.8 100.2 102.1 112.7l24.7 6.3v142.7c-44.2-5.9-69-29.5-74.1-61.3-.6-3.8-4-6.6-7.9-6.6H363c-4.7 0-8.4 4-8 8.7 4.5 55 46.2 105.6 135.2 112.1V761c0 4.4 3.6 8 8 8h28.4c4.4 0 8-3.6 8-8.1l-.2-31.7c78.3-6.9 134.3-48.8 134.3-124-.1-69.4-44.2-100.4-109-116.4zm-68.6-16.2c-5.6-1.6-10.3-3.1-15-5-33.8-12.2-49.5-31.9-49.5-57.3 0-36.3 27.5-57 64.5-61.7v124zM534.3 677V543.3c3.1.9 5.9 1.6 8.8 2.2 47.3 14.4 63.2 34.4 63.2 65.1 0 39.1-29.4 62.6-72 66.4z" } }] }, "name": "dollar", "theme": "outlined" };
/* harmony default export */ var asn_DollarOutlined = (DollarOutlined);

// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 5 modules
var AntdIcon = __webpack_require__(89099);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/DollarOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY



var DollarOutlined_DollarOutlined = function DollarOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, props), {}, {
    ref: ref,
    icon: asn_DollarOutlined
  }));
};
DollarOutlined_DollarOutlined.displayName = 'DollarOutlined';
/* harmony default export */ var icons_DollarOutlined = (/*#__PURE__*/react.forwardRef(DollarOutlined_DollarOutlined));

/***/ }),

/***/ 4828:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ icons_FundOutlined; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(1413);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/FundOutlined.js
// This icon file is generated automatically.
var FundOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M926 164H94c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V196c0-17.7-14.3-32-32-32zm-40 632H134V236h752v560zm-658.9-82.3c3.1 3.1 8.2 3.1 11.3 0l172.5-172.5 114.4 114.5c3.1 3.1 8.2 3.1 11.3 0l297-297.2c3.1-3.1 3.1-8.2 0-11.3l-36.8-36.8a8.03 8.03 0 00-11.3 0L531 565 416.6 450.5a8.03 8.03 0 00-11.3 0l-214.9 215a8.03 8.03 0 000 11.3l36.7 36.9z" } }] }, "name": "fund", "theme": "outlined" };
/* harmony default export */ var asn_FundOutlined = (FundOutlined);

// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 5 modules
var AntdIcon = __webpack_require__(89099);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/FundOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY



var FundOutlined_FundOutlined = function FundOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, props), {}, {
    ref: ref,
    icon: asn_FundOutlined
  }));
};
FundOutlined_FundOutlined.displayName = 'FundOutlined';
/* harmony default export */ var icons_FundOutlined = (/*#__PURE__*/react.forwardRef(FundOutlined_FundOutlined));

/***/ }),

/***/ 34140:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ BrokerQuickLinks; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71230);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15746);
/* harmony import */ var _shared_QuickLinks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87160);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);





var renderable = function renderable(broker) {
  var commodityTrading = broker.commodity_trading;
  var currencyTrading = broker.currency_trading;
  var accountOpeningProcess = broker.account_opening_process;
  var demat = broker.demat,
      exposure = broker.exposure; // If any of the option is availble then quickLInks are renderable
  // commodityTrading(For now only) || Otheroption || Another Option

  return commodityTrading || currencyTrading || accountOpeningProcess || demat || exposure;
};

function BrokerQuickLinks(_ref) {
  var broker = _ref.broker,
      RenderReview = _ref.RenderReview,
      currentPage = _ref.currentPage;
  if (!broker) return null;
  var name = broker.name,
      slug = broker.slug,
      commodityTrading = broker.commodity_trading,
      currencyTrading = broker.currency_trading,
      accountOpeningProcess = broker.account_opening_process,
      demat = broker.demat,
      exposure = broker.exposure;
  var title = '';
  var linkList = [];

  if (RenderReview || renderable(broker)) {
    title = 'Quick Links';

    if (RenderReview) {
      linkList.push({
        href: '/broker/[slug]/',
        as: "/broker/".concat(slug, "/"),
        linkText: " ".concat(name, " Review")
      });
    }

    if (accountOpeningProcess && currentPage !== 'AccountOpening') {
      linkList.push({
        href: '/broker/[slug]/account-opening-process',
        as: "/broker/".concat(slug, "/account-opening-process"),
        linkText: " ".concat(name, " Account Opening Process")
      });
    }

    if (commodityTrading && currentPage !== 'CommodityTrading') {
      linkList.push({
        href: '/broker/[slug]/commodity-trading',
        as: "/broker/".concat(slug, "/commodity-trading"),
        linkText: " ".concat(name, " Commodity Trading")
      });
    }

    if (currencyTrading && currentPage !== 'currencyTrading') {
      linkList.push({
        href: '/broker/[slug]/currency-trading',
        as: "/broker/".concat(slug, "/currency-trading"),
        linkText: " ".concat(name, " Currency Trading")
      });
    }

    if (demat && currentPage !== 'dematAccountReviewChargesOpening') {
      linkList.push({
        href: '/broker/[slug]/demat-account-review-charges-opening',
        as: "/broker/".concat(slug, "/demat-account-review-charges-opening"),
        linkText: " ".concat(name, " Demat account review")
      });
    }

    if (exposure && currentPage !== 'margin-exposure-leverage') {
      linkList.push({
        href: '/broker/[slug]/margin-exposure-leverage',
        as: "/broker/".concat(slug, "/margin-exposure-leverage"),
        linkText: " ".concat(name, " Exposure")
      });
    }

    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        span: 24,
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_shared_QuickLinks__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
          title: title,
          linkList: linkList
        })
      })
    });
  }

  return null;
}
BrokerQuickLinks.defaultProps = {
  RenderReview: false,
  currentPage: 'broker'
};

/***/ }),

/***/ 31834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ BrokerTradingTools; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/shared/QuickLinks.tsx
var QuickLinks = __webpack_require__(87160);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/shared/TradingTools.tsx



function TradingTools(props) {
  var title = props.title,
      softwares = props.softwares;
  var linkList = [];

  if (softwares) {
    softwares.map(function (software) {
      linkList.push({
        href: '/software/[slug]/',
        as: "/software/".concat(software.attributes.slug),
        linkText: " ".concat(software.attributes.name)
      });
      return linkList;
    });
  }

  return softwares ? /*#__PURE__*/(0,jsx_runtime.jsx)(QuickLinks/* default */.Z, {
    title: title,
    linkList: linkList
  }) : null;
}
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
;// CONCATENATED MODULE: ./components/broker/BrokerTradingTools.tsx




function BrokerTradingTools(_ref) {
  var _softwares$data;

  var broker = _ref.broker;
  var name = broker.name,
      softwares = broker.softwares;
  var title = '';

  if ((softwares === null || softwares === void 0 ? void 0 : (_softwares$data = softwares.data) === null || _softwares$data === void 0 ? void 0 : _softwares$data.length) > 0) {
    title = "".concat(name, " Trading Tools");
    return /*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
      style: {
        marginBottom: '16px'
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
        span: 24,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(TradingTools, {
          title: title,
          softwares: softwares.data
        })
      })
    });
  }

  return null;
}

/***/ }),

/***/ 20851:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ OtherBrokersList; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _shared_QuickLinks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87160);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4828);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4795);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71230);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15746);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);







function OtherBrokersList(_ref) {
  var allBrokers = _ref.allBrokers,
      currentBroker = _ref.currentBroker,
      country = _ref.country;
  var fullServiceLinkList = [];
  var discountLinkList = [];
  var brokers = [];
  allBrokers.forEach(function (broker) {
    var _broker$attributes = broker.attributes,
        name = _broker$attributes.name,
        slug = _broker$attributes.slug,
        broker_type = _broker$attributes.broker_type;

    if (broker.attributes.country.name === country.name) {
      brokers.push({
        href: '/broker/[slug]',
        as: "/broker/".concat(slug),
        linkText: " ".concat(name, " Review")
      });
    }

    if (slug === currentBroker.slug) {
      return true;
    }

    if (broker_type === 'full_service') {
      fullServiceLinkList.push({
        href: '/broker/[slug]',
        as: "/broker/".concat(slug),
        linkText: " ".concat(name, " Review")
      });
    }

    if (broker_type === 'discount') {
      discountLinkList.push({
        href: '/broker/[slug]',
        as: "/broker/".concat(slug),
        linkText: " ".concat(name, " Review")
      });
    }

    return true;
  });
  if (country.name === 'India') return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
      style: {
        marginBottom: '16px'
      },
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        span: 24,
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_shared_QuickLinks__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
          title: "Discount Brokers",
          linkList: discountLinkList,
          icon: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_ant_design_icons__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {})
        })
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
      style: {
        marginBottom: '16px'
      },
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        span: 24,
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_shared_QuickLinks__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
          title: "Full Service Brokers",
          linkList: fullServiceLinkList,
          icon: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_ant_design_icons__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
        })
      })
    })]
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    style: {
      marginBottom: '16px'
    },
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
      span: 24,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_shared_QuickLinks__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        title: "All Brokers",
        linkList: brokers,
        icon: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_ant_design_icons__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {})
      })
    })
  });
}

/***/ }),

/***/ 65060:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ Broker; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./components/broker/OtherBrokersQL.tsx
var OtherBrokersQL = __webpack_require__(20851);
// EXTERNAL MODULE: ./components/shared/PaginatedArticles.tsx
var PaginatedArticles = __webpack_require__(3149);
// EXTERNAL MODULE: ./components/broker/BrokerTradingTools.tsx + 1 modules
var BrokerTradingTools = __webpack_require__(31834);
// EXTERNAL MODULE: ./components/broker/BrokerQuickLinks.js
var BrokerQuickLinks = __webpack_require__(34140);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/broker/BrokerFAQ.js








function BrokerFAQ(_ref) {
  var broker = _ref.broker,
      allBrokers = _ref.allBrokers;
  var customArticles = broker.articles.data,
      brokerArticlesCount = broker.brokerArticlesCount;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(row/* default */.Z, {
    className: "page-wrapper page",
    gutter: [16, 16],
    style: {
      width: '100%',
      padding: '16px'
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
      xs: 24,
      md: 16,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
        className: "row-wrapper",
        style: {
          width: '100%'
        },
        children: customArticles.length > 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)(PaginatedArticles/* default */.Z, {
          articles: customArticles,
          count: brokerArticlesCount,
          type: "broker"
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)("h5", {
          children: " No FAQs Found "
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(col/* default */.Z, {
      xs: 24,
      md: 8,
      style: {
        marginTop: 16
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BrokerQuickLinks/* default */.Z, {
        broker: broker
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(BrokerTradingTools/* default */.Z, {
        broker: broker
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(OtherBrokersQL/* default */.Z, {
        allBrokers: allBrokers,
        currentBroker: broker,
        country: broker.country
      })]
    })]
  });
}
// EXTERNAL MODULE: ./components/shared/schema/article.tsx
var article = __webpack_require__(28262);
// EXTERNAL MODULE: ./layouts/application.tsx + 4 modules
var application = __webpack_require__(8182);
// EXTERNAL MODULE: ./shared/util.tsx + 6 modules
var util = __webpack_require__(77713);
;// CONCATENATED MODULE: ./pages/broker/[slug]/faq/[[...page]].tsx










var title = function title(_ref) {
  var broker = _ref.broker,
      page = _ref.page;
  return "Frequently asked questions about ".concat(broker.name, " - Page ").concat(page || 1);
};

var description = function description(_ref2) {
  var broker = _ref2.broker;
  return "".concat(broker.name, " Frequently asked questions (FAQ). As queries about ").concat(broker.name);
};

var __N_SSP = true;
function Broker(props) {
  var router = (0,next_router.useRouter)();
  var asPath = router.asPath;
  var brokerData = props.data,
      page = props.page;
  var brokers = brokerData.brokers,
      allBrokers = brokerData.all_brokers.data,
      navCalculators = brokerData.nav_calculators.data,
      allPages = brokerData.all_pages.data;
  var broker = brokers.data[0].attributes;
  var pageTitle = title({
    broker: broker,
    page: page
  });
  var pageDescription = description({
    broker: broker
  });
  var urlWithoutPage = (0,util/* pageUri */.TI)("/broker/".concat(broker.slug, "/faq"));
  var country = {
    attributes: {
      name: brokers.data[0].attributes.country.name
    }
  };
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(application/* default */.Z, {
    allBrokers: allBrokers,
    navCalculators: navCalculators,
    allPages: allPages,
    country: country,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: pageTitle
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: pageDescription
      }), page === 1 && /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "canonical",
        href: urlWithoutPage
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(article/* ArticleJsonLd */.d, {
      url: (0,util/* pageUri */.TI)(asPath),
      title: pageTitle,
      description: pageDescription
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(BrokerFAQ, {
      broker: broker,
      allBrokers: allBrokers
    })]
  });
}

/***/ }),

/***/ 73234:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/broker/[slug]/faq/[[...page]]",
      function () {
        return __webpack_require__(65060);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5407,2453,3229,7752,2913,1945,2682,7527,6873,3679,5045,2841,8182,1997,9774,2888,179], function() { return __webpack_exec__(73234); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);